import { render } from "./TreeDataAndLazyMode.vue?vue&type=template&id=4385f819"
import script from "./TreeDataAndLazyMode.vue?vue&type=script&lang=js"
export * from "./TreeDataAndLazyMode.vue?vue&type=script&lang=js"
script.render = render

export default script